import React from "react"
import styled from "styled-components"

export default function Title({
  title0,
  title1,
  title2,
  title3,
  title4,
  type,
  onClick,
  desc
}) {
  return (
    <Wrapper className={type === "question" && "question"} onClick={onClick}>
      {title0 && <h1 className="row1">{title0}</h1>}
      <div className="row1">
        <h1>{title1}</h1>
        <h1>{title2}</h1>
      </div>
      {title3 && (
        <div className="row2">
          <h1>{title3}</h1>
          <h1>{title4}</h1>
        </div>
      )}
      {desc && (
        <DescWrapper>
          <h3>{desc}</h3>
        </DescWrapper>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  padding: 42px 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 1000px) {
    padding: 42px;
  }
  @media (max-width: 768px) {
    padding: 30px 10px;
  }
  .row1 {
    display: flex;
    gap: 24px;
    align-items: center;
    @media (max-width: 1000px) {
      gap: 0;
    }
  }
  .row2 {
    display: flex;
    gap: 80px;

    @media (max-width: 1000px) {
      gap: 60px;
    }

    @media (max-width: 768px) {
      gap: 00px;
    }
  }
  h1 {
    color: #ffffff;
    font-size: 64px;
    line-height: 1.3;
    letter-spacing: 10px;
    margin: 0;
    text-shadow:
      0 0 40px #00ffeeaa,
      0 0 20px #000;
    @media (max-width: 1000px) {
      font-size: 60px;
    }
    @media (max-width: 768px) {
      font-size: 36px;
      letter-spacing: 2px;
    }
    @media (max-width: 600px) {
      font-size: 32px;
    }
  }
  &.question {
    /* background-color: #fff; */
    align-items: center;
    padding: 32px 40px;
    /* height: 100px; */
    position: relative;
    @media (max-width: 768px) {
      padding: 30px 16px;
      max-height: 100px;
    }

    .row1 {
      width: 100%;
      gap: 36px;
      justify-content: center;
      align-items: center;
      @media (max-width: 768px) {
      }

      h1 {
        font-size: 20px;
        letter-spacing: 2px;
        @media (max-width: 768px) {
          font-size: 16px;
          text-align: center;
        }
        &:nth-child(1) {
          color: #00fff0;
          font-size: 32px;
          text-shadow:
            0 0 40px #ffffffaa,
            0 0 20px #000;
          @media (max-width: 768px) {
            position: absolute;
            top: -24px;
          }
        }
      }
    }
  }
`

const DescWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 0 40px;
  h3 {
    text-align: end;
    color: #ffffff;
    font-size: 24px;
    margin: 0;
    letter-spacing: 4px;
    font-weight: 700;
    padding: 4px 8px;

    text-shadow:
      0 0 40px #ffffffaa,
      0 0 20px #000;
    animation: twinkling 5s infinite;
  }
  &:before {
    content: "";
    background-color: #ffffff;
    flex: 1;
    height: 2px;
  }

  @media (max-width: 1000px) {
    justify-content: center;
    margin-top: 20px;
    h3 {
      font-size: 18px;
    }
    &:before {
      content: "";
      flex: 1 0 20px;
      height: 2px;
    }
    &:after {
      content: "";
      flex: 1 0 20px;
      height: 2px;
    }
  }
  @media (max-width: 768px) {
    --DescCircle: 120px;
    position: absolute;
    bottom: -100px;
    right: 0px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--DescCircle);
    height: var(--DescCircle);
    border: 1px solid #fff;
    border-radius: 50%;
    h3 {
      text-align: center;
      transform: translate(0, 6px);
    }
    &:before {
      content: "";
      display: none;
    }
    &:after {
      content: "";
      display: none;
    }
  }

  @keyframes twinkling {
    0% {
      opacity: 1;
    }
    28% {
      opacity: 0.8;
    }
    30% {
      opacity: 0.3;
    }
    32% {
      opacity: 0.8;
    }
    35% {
      opacity: 0.3;
    }
    40% {
      opacity: 1;
    }
  }
`
